import React from "react";


function Contents(){
    return (
        <div className="container_projects">
            <div>
                <p style={{fontSize: "30px", fontWeight: "bold"}}>
                    <a href="https://github.com/CyanHsu/Stock-Transaction-Simulator.git" style={{textDecoration : "none"}}>  Stock trading simulator</a>
                  </p>

                <b style={{fontStyle: 'italic'}}>JavaScript, Node.js, Express.js, MySQL, HTML, AWS</b>
                <p>A full-stack stock trading simulation website, offering users to practice trading stocks with 100k
                    token</p>
            </div>
            <div>
                {/*<p>put screenshot here</p>*/}
                <img style={{height: 250, width: 400, padding: 10}} src={"https://i.imgur.com/SsB10k4.jpeg"}
                     alt={"stock"}/>
                <img style={{height: 250, width: 400, padding: 10}} src={"https://i.imgur.com/1kusmkw.jpeg"}
                     alt={"stock"}/>
            </div>

            <div>
                <p style={{fontSize: "30px", fontWeight: "bold"}}>
                    <a href="https://github.com/CyanHsu/Android-Painting-App.git"
                       style={{textDecoration: "none"}}> Android drawing app</a>

                </p>
                <b style={{fontStyle: 'italic'}}>Kotlin, Android studio, Firebase</b>

                <p>An Android drawing app with Jetpack Compose UI in Kotlin, offering multiple features like pen
                    settings, persistence data through Room, and cross-app image sharing</p>
            </div>
            <div>
                <img style={{height: 350, width: 200, padding: 10}} src={"https://i.imgur.com/C0YrA8Y.gif"}
                     alt={"stock"}/>
            </div>


            <div>
                <p style={{fontSize: "30px", fontWeight: "bold"}}>
                    <a href="http://slchousingprice.s3-website-us-west-1.amazonaws.com/"
                       style={{textDecoration: "none"}}>Salt Lake County housing price heat map</a>

                    </p>
                <b style={{fontStyle: 'italic'}}>Python, JavaScript, D3.js</b>
                <p>Visualized the housing price difference between cities in Salt Lake County
                </p>
            </div>
            <div>
                <img style={{height: 250, width: 400, padding: 10}} src={"https://i.imgur.com/4zSfBGD.png"}
                     alt={"stock"}/>
            </div>

            <div>
                <p style={{fontSize: "30px", fontWeight: "bold"}}>
                    <a href="https://github.com/CyanHsu/ChatRoom.git"
                       style={{textDecoration: "none"}}>Web& mobile chat room</a>
                </p>
                <b style={{fontStyle: 'italic'}}>Java, JavaScript, HTML</b>
                <p>A chat room application with web and mobile interface
                </p>
            </div>
            <div>
                <img style={{height: 250, width: 400, padding: 10}} src={"https://i.imgur.com/4ncBAdX.png"}
                     alt={"stock"}/>
                <img style={{height: 250, width: 150, padding: 10}} src={"https://i.imgur.com/DTQx0Wo.png"}
                     alt={"stock"}/>
            </div>

            <div>
                <p style={{fontSize: "30px", fontWeight: "bold"}}>
                    <a href="https://github.com/CyanHsu/LMS-Lite-w-MySQL.git"
                       style={{textDecoration: "none"}}>LMS lite </a></p>
                <b style={{fontStyle: 'italic'}}>C#, SQL</b>
                <p>A simple learning management system with MVC structure, retrieving and editing the database with C#
                    LINQ
                </p>
            </div>
            <div>
                <p></p>
            </div>

            <div>
                <p style={{fontSize: "30px", fontWeight: "bold"}}>
                    <a href="https://github.com/CyanHsu/DNS-Resolver.git"
                       style={{textDecoration: "none"}}> DNS resolver </a>
                   </p>
                <b style={{fontStyle: 'italic'}}>Java</b>
                <p>A DNS resolver with cache feature to store the response IP to reduce 90% of the response time

                </p>
            </div>
            <div>
                <p></p>
            </div>

            <div>
                <p style={{fontSize: "30px", fontWeight: "bold"}}>
                    <a href="https://github.com/CyanHsu/DNS-Resolver.git"
                       style={{textDecoration: "none"}}>Unix shell</a>
                    </p>
                <b style={{fontStyle: 'italic'}}>C++</b>
                <p>A custom shell program with I/O redirection, pipe and some shell builtins with C++, offering features
                    like background process handling, environment variable support, and tab completion
                </p>
            </div>
            <div>
                <p></p>
            </div>


        </div>
    );
}

function Projects() {
    return (
        <div className="header">
            <h1 style={{fontSize: "50px"}}>Projects</h1>
            <Contents/>

        </div>
    );
}

export default Projects;